import React from 'react';
import { Box, styled, Typography } from '@mui/material';
// Components
import { AuthLayout, LoginForm } from '@components/auth';
import { AppCard } from '@components';

const Wrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(5),
  minHeight: 'calc(100vh - 63px)',
  maxWidth: 480,
  margin: '0 auto',

  '& > *': {
    width: '100%',
  },
}));

const logo = () => {
  if (import.meta.env.VITE_SITE === 'Paybilt') {
    return '/images/paybilt.png';
  } else {
    return '/images/payper.png';
  }
};

const Login = () => {
  const [privacy, setPrivacy] = React.useState('');
  const [terms, setTerms] = React.useState('');

  React.useEffect(() => {
    if (import.meta.env.VITE_SITE === 'Paybilt') {
      setPrivacy('https://paybilt.com/privacy/');
      setTerms('https://paybilt.com/terms-conditions/');
    } else {
      setPrivacy('https://payper.ca/privacy');
      setTerms('https://payper.ca/terms-conditions');
    }
  }, []);

  return (
    <AuthLayout>
      <Wrap>
        <div>
          <Box mb={3}>
            <img src={logo()} width={100} alt={import.meta.env.VITE_SITE} />
          </Box>

          <AppCard title="Sign in to your account">
            <LoginForm />
          </AppCard>

          <Typography py={3} variant="body2" color="textSecondary">
            {'© '}
            {new Date().getFullYear()} {import.meta.env.VITE_SITE} {'.'}{' '}
            <a href={privacy} target="_blank">
              Privacy
            </a>{' '}
            &{' '}
            <a href={terms} target="_blank">
              Terms
            </a>
          </Typography>
        </div>
      </Wrap>
    </AuthLayout>
  );
};

export default Login;
